module.exports = __webpack_public_path__ + "img/kurotori.c96ce1d6.png";